import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import FormModal from '../../components/Modals/FormModal';
import InputField from '../../components/Forms/Input/InputField';
import TextAreaField from '../../components/Forms/Input/TextAreaField';
import SelectField from '../../components/Forms/Input/SelectField';
import FileUploader from '../Uploader/FileUploader';
import {
  updateTemplateField,
  closeEditModalAndReset,
} from '../../store/slices/documentTemplate/electronicDocumentTemplateSlice';
import { useDocumentType } from '../../hooks/useDocumentType';
import { useDocumentTemplate } from '../../hooks/documentTemplate/useDocumentTemplate';

interface Props {
  isOpen: boolean;
  onUpdate: (file: File | null) => void;
}

const DocumentTemplateEditPopup: React.FC<Props> = ({
  isOpen,
  onUpdate,
}) => {
  const dispatch = useDispatch();
  const { form } = useDocumentTemplate(); // ⚠️ Asegúrate que ya viene el template seleccionado
  const { fetchDocumentTypeDropdown, documentTypeDropdown } = useDocumentType();

  const [templateFile, setTemplateFile] = useState<File | null>(null);

  useEffect(() => {
    if (isOpen) {
      fetchDocumentTypeDropdown();
      setTemplateFile(null); // Limpiar archivo si se edita
    }
  }, [isOpen]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const parsedValue = name === 'documentTypeId' ? Number(value) : value;
    dispatch(updateTemplateField({ field: name as any, value: parsedValue }));
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={() => dispatch(closeEditModalAndReset())}
      title="Editar Plantilla de Documento Electrónico"
      maxWidth="max-w-4xl"
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onUpdate(templateFile); // Enviar el archivo modificado (si hay)
        }}
      >
        <SelectField
          label="Tipo de Documento"
          name="documentTypeId"
          iconKey="document"
          value={form.documentTypeId}
          onChange={handleChange}
          options={documentTypeDropdown.map((item) => ({
            label: item.name,
            value: item.id,
          }))}
          placeholder="Seleccione"
          disabled // 🛑 No editable en modo edición
        />

        <InputField
          label="Versión"
          name="version"
          iconKey="code"
          value={form.version || ''}
          onChange={handleChange}
          type="text"
        />

        <TextAreaField
          label="Descripción"
          name="description"
          value={form.description || ''}
          onChange={handleChange}
          placeholder="Ingrese una descripción de la plantilla"
        />

        <div className="md:col-span-2">
          <FileUploader
            label="Archivo de Plantilla HTML (opcional)"
            accept="text/html"
            currentFile={templateFile}
            onFileChange={setTemplateFile}
          />
        </div>

        <div className="md:col-span-2">
          <button
            type="submit"
            className="w-full rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
          >
            Actualizar Plantilla
          </button>
        </div>
      </form>
    </FormModal>
  );
};

export default DocumentTemplateEditPopup;
